import { render, staticRenderFns } from "./notData.vue?vue&type=template&id=7d470527&scoped=true"
import script from "./notData.vue?vue&type=script&lang=js"
export * from "./notData.vue?vue&type=script&lang=js"
import style0 from "./notData.vue?vue&type=style&index=0&id=7d470527&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d470527",
  null
  
)

export default component.exports